export default "__VITE_ASSET__$BIInQa6Se31$ZXuheMU4g__"